export default __webpack_public_path__ + "static/media/products_521.f9869e64.jpg";